var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3459 1V8.3125C11.3459 8.53628 11.257 8.75089 11.0988 8.90912C10.9406 9.06736 10.7259 9.15625 10.5022 9.15625C10.2784 9.15625 10.0638 9.06736 9.90555 8.90912C9.74731 8.75089 9.65842 8.53628 9.65842 8.3125V3.03906L2.09912 10.597C1.94061 10.7555 1.72563 10.8445 1.50146 10.8445C1.2773 10.8445 1.06232 10.7555 0.903807 10.597C0.745299 10.4384 0.65625 10.2235 0.65625 9.9993C0.65625 9.77513 0.745299 9.56015 0.903807 9.40164L8.4631 1.84375H3.18967C2.96589 1.84375 2.75128 1.75486 2.59305 1.59662C2.43481 1.43839 2.34592 1.22378 2.34592 1C2.34592 0.776224 2.43481 0.561612 2.59305 0.403379C2.75128 0.245145 2.96589 0.15625 3.18967 0.15625H10.5022C10.7259 0.15625 10.9406 0.245145 11.0988 0.403379C11.257 0.561612 11.3459 0.776224 11.3459 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.6b06b8dcac7f605253356d3c83004c85.svg";
export { ForwardRef as ReactComponent };